import React, { useCallback, useEffect, useState } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomTextEditor.css";
import { debounce, set } from "lodash";
import html2canvas from "html2canvas";
import "bootstrap-icons/font/bootstrap-icons.css";


const CustomTextEditor = ({
  setTextInput,
  textInput,
  setArchObj,
  containerRef,
  setTextImageSrc,
  setLetterCount
}) => {
  const [text, setText] = useState(textInput || "");
  const [fontFamily, setFontFamily] = useState("Baziporen, sans-serif");
  const [fontSize, setFontSize] = useState(48);
  const [color, setColor] = useState("#cc9933");
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [shape, setShape] = useState("straight");

  const fontFamilyList = [
    "Baziporen, sans-serif",
    "Talpiot, serif",
    "BA Platforma, sans-serif",
    "BA Yad Maran, sans-serif",
    "BA Tzahlulim, sans-serif",
    "BA Nizozot Regular, sans-serif",
    "Bahacorech Regular, sans-serif",
    "BA Segolta Regular, sans-serif",
    "BA Tzarfati Bold, sans-serif",
    "FB Empatica Bold, sans-serif",
    "FB Kidush Bold, sans-serif",
    "FB Liddar Bold, sans-serif",
    "FB Maarav Bold, sans-serif",
    "FB Melatef Mudgash, sans-serif",
    "FB Vayikra, sans-serif",
    "Lia Batkol Regular, sans-serif",
    "Lia Romantica Regular, sans-serif",
    "Ostrovsky Bold, sans-serif",
    "Prinles, sans-serif",
    "Puncher, sans-serif",
    "Rag Marom Regular, sans-serif",
    "Secely MF Bold, sans-serif",
    "Ploni Black, sans-serif",
    "Ploni Bold, sans-serif",
    "Arial, Helvetica, sans-serif",
    "Courier New, Courier, monospace",
    "Georgia, serif",
    "Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif",
    "Tahoma, Geneva, sans-serif",
    "Times New Roman, Times, serif",
    "Verdana, Geneva, sans-serif",
  ];
  useEffect(() => {
    if (shape === "arch" && text) {
      setTextInput(text);
      updateCanvas();
      setArchObj({
        text: text,
        font: fontFamily,
        color: color,
      });
      
    } else if(shape === "straight" && text) {
      console.log("hello", color)
      setArchObj(null);
      setTextInput(text);
      updateCanvas();
  
      if (containerRef.current) {
        containerRef.current.style.fontFamily = fontFamily;
        containerRef.current.style.fontSize = `${fontSize}px`;
        containerRef.current.style.color = color;
        containerRef.current.style.textAlign = "center";
      }
  
    } else {
      setTextImageSrc(null);
    }
    
  }, [text, fontFamily, fontSize, shape, color, setTextInput]);



  const handleKeyboardChange = (input) => {
    setText((prev) => prev + input);
  };

  const getLetterCount = () => {
    const plainText = text
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ") 
        .trim();

        const letters = plainText.replace(/\s+/g, "").length;
        setLetterCount(letters);
        return letters
  }

  const handleFontFamilyChange = (e) => setFontFamily(e.target.value);
  // const handleColorChange = (e) => setColor(e.target.value);
  const toggleKeyboard = () => setShowKeyboard(!showKeyboard);
  const increaseFontSize = () => setFontSize((prev) => prev + 2);
  const decreaseFontSize = () => setFontSize((prev) => Math.max(prev - 2, 8));

  const debouncedChangeHandler = useCallback(
    debounce((selectedColor) => {
      setColor(selectedColor);
    }, 100),
    []
  );


  const handleTextChange = (e) => {
    const newText = e.target.value;
    setText(newText);
  };

  const updateCanvas = useCallback(debounce(async () => {
    if (containerRef.current) {
      // const currentFontFamily = window.getComputedStyle(containerRef.current).fontFamily;
      // const currentFontSize = window.getComputedStyle(containerRef.current).fontSize;

      // containerRef.current.style.fontFamily = currentFontFamily;
      // containerRef.current.style.fontSize = currentFontSize;

      const canvas = await html2canvas(containerRef.current, {
        backgroundColor: null,
      });
      const img = new window.Image();
      img.crossOrigin = "Anonymous";
      img.src = canvas.toDataURL("image/png");
      img.onload = () => setTextImageSrc(img);
    }
  }, 100),[]);

  const handleClearText = () => {
    setText("");
    setArchObj(null);
    setTextImageSrc(null);
    setTextInput("");
    setFontFamily("Baziporen, sans-serif");
    setFontSize(48);
    setColor("#FFD700");
    setShape("straight");
  };

  return (
    <div className="container mt-4">
      <div>
        <label htmlFor="textInput" className="form-label fs-16 fw-400" style={{ color: "black" }}>
          Enter Text
        </label>
        <div className="mb-3 d-flex gap-2">
          <input
            id="textInput"
            type="text"
            className="form-control"
            value={text}
            onChange={handleTextChange}
          />
          <button
            className="btn btn-outline-secondary me-2"
            onClick={toggleKeyboard}
          >
            <i className="bi bi-keyboard"></i>
          </button>
        </div>
      </div>

      <div>
        <label htmlFor="fontFamily" className="form-label fs-16 fw-400" style={{ color: "black" }}>
          Font
        </label>
        <div className="mb-3 d-flex align-items-center gap-3">
          <select
            className="form-select si"
            id="fontFamily"
            value={fontFamily}
            onChange={handleFontFamilyChange}
            style={{ height: "35px" }}
          >
            {fontFamilyList.map((font, index) => (
              <option key={index} value={font}>
                {font}
              </option>
            ))}
          </select>
          <div className="d-flex">
            <button
              className="btn btn-outline-secondary me-2"
              onClick={decreaseFontSize}
              disabled={shape === "arch"}
            >
              <i className="bi bi-dash"></i>
            </button>
            <button
              className="btn btn-outline-secondary me-2"
              onClick={increaseFontSize}
              disabled={shape === "arch"}

            >
              <i className="bi bi-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div>
        <label htmlFor="fontFamily" className="form-label fs-16 fw-400" style={{ color: "black" }}>
          Color
        </label>
        <div className="d-flex align-items-center me-2 gap-5">
          <input
            type="color"
            id="color-picker"
            className="form-control form-control-color"
            value={color}
            onChange={(e) => {
              const selectedColor = e.target.value;
              debouncedChangeHandler(selectedColor);
            }}
            title="Choose your color"
          />
          <div className="d-flex">
            {["#ff0000", "#00ff00", "#0000ff", "#cc9933", "#000000"].map(
              (boxColor, index) => (
                <div
                  key={index}
                  onClick={() => setColor(boxColor)}
                  style={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: boxColor,
                    margin: "0 4px",
                    cursor: "pointer",
                  }}
                />
              )
            )}
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px", marginBottom: "20px" }} className="d-flex justify-content-between">
        <div>
        <button
          className={"btn btn-sm btn-outline-primary me-2"}
          // style={{ height: "25px"}}
          onClick={() => setShape("straight")}
        >
          Straight
        </button>
        <button
          className={"btn btn-sm btn-outline-primary font-size-12 me-2"}
          // style={{ height: "25px"}}
          onClick={() => setShape("arch")}
        >
          Arch
        </button>
        <button
          className={"btn btn-sm btn-outline-primary font-size-12 me-2"}
          // style={{ height: "25px"}}
          onClick={handleClearText}
        >
          Clear
        </button>
        </div>
        <div>
          <p style={{ color: "black" }}>Letter Count: {getLetterCount()}</p>
        </div>
      </div>

      {/* <div
        className="p-3 border"
        style={{
          fontFamily: fontFamily,
          fontSize: `${fontSize}px`,
          color: color,
          textAlign: "center",
          // borderRadius: shape === "arch" ? "50px" : "0",
          // lineHeight: shape === "arch" ? "1.5" : "normal",
        }}
      >
        {text || "Your styled text will appear here."}
      </div> */}

      {/* Modal for Keyboard */}
      {showKeyboard && (
        <div
          className="modal fade show "
          // tabIndex="-1"
          style={{ display: "block", paddingRight: "15px", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          aria-labelledby="keyboardModalLabel"
          aria-hidden="true"
             onClick={(e) => {
      // Check if the click is outside the modal-content
      if (e.target.classList.contains("modal")) {
        toggleKeyboard();
      }
    }}
        >
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="keyboardModalLabel">
                  Virtual Keyboard
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={toggleKeyboard}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <Keyboard
                  onChange={handleKeyboardChange}
                  layout={{
                    default: [
                      " 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
                      "{tab} / ' \u05e7 \u05e8 \u05d0 \u05d8 \u05d5 \u05df \u05dd \u05e4 ] [ :",
                      "{lock} \u05e9 \u05d3 \u05d2 \u05db \u05e2 \u05d9 \u05d7 \u05dc \u05da \u05e3 , {enter}",
                      "{shift} \u05d6 \u05e1 \u05d1 \u05d4 \u05e0 \u05de \u05e6 \u05ea \u05e5 . {shift}",
                      ".com @ {space}",
                    ],
                    shift: [
                      "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
                      "{tab} Q W E R T Y U I O P { } |",
                      '{lock} A S D F G H J K L : " {enter}',
                      "{shift} Z X C V B N M < > ? {shift}",
                      ".com @ {space}",
                    ],
                  }}
                  style={{
                    marginTop: "20px",
                    width: "90%",
                    fontSize: "16px",
                    height: "auto",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomTextEditor;
